module.exports = __webpack_public_path__ + "img/hk.8000d438.png";